// ============================================================
// useMediaQuery — kleiner Hook, der auf einen CSS-Media-Query
// hört. Quelle der Wahrheit für JS-gesteuerte Responsive-Logik
// (z. B. Watchlist-Drawer im Terminal). Breakpoints identisch
// zu App.css: Phone < 768, Tablet 768–1024, Desktop > 1024.
// ============================================================
import { useEffect, useState } from 'react';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    // addEventListener('change') — Safari < 14 kennt nur addListener.
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return matches;
}

// Bequeme Aliase auf die App-Breakpoints.
export const usePhone = () => useMediaQuery('(max-width: 767px)');
export const useTablet = () => useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
export const useTabletDown = () => useMediaQuery('(max-width: 1024px)');
